export const renderConfig = {
  pixelRatioCap: 2,
  clearColor: 0x05060a,
  camera: {
    fov: 72,
    near: 0.1,
    far: 42000,
    initialPosition: { x: 0, y: 12, z: 28 } as const
  }
} as const;
